import { AxiosRequestConfig } from 'axios';
import { call, CallEffect, PutEffect } from 'redux-saga/effects';
import { apiClient } from 'utils';

export default function* apiSaga(
  requestConfig: AxiosRequestConfig,
): Generator<CallEffect | PutEffect> {
  // eslint-disable-next-line no-useless-catch
  try {
    return yield call<(config: AxiosRequestConfig) => void>(apiClient, requestConfig);
  } catch(err) {
    throw err;
  }
}
